import { jsxs, Fragment, jsx } from "react/jsx-runtime";
import Script from "next/script";
import B2BLayout from "../B2BLayout/B2BLayout.esm.js";
import ZillowFrontPorchLogo from "./assets/zillow-front-porch.svg.esm.js";
import { HEADER_CTAS, FOOTER_COLUMNS, LAYOUT_MENU_ITEMS } from "./constants/layout.esm.js";
const ZillowNewsLayout = ({
  children,
  submenu,
  header,
  router,
  environment,
  knotchAccountId
}) => {
  const img = {
    src: ZillowFrontPorchLogo,
    alt: "Zillow Front Porch",
    width: 200,
    height: 40,
    blurHeight: 0,
    blurWidth: 0,
    link: "/news/"
  };
  return /* @__PURE__ */ jsxs(Fragment, { children: [
    !!knotchAccountId && /* @__PURE__ */ jsx(Script, { src: `https://www.knotch-cdn.com/ktag/latest/ktag.min.js?accountId=${knotchAccountId}` }),
    /* @__PURE__ */ jsx(B2BLayout, { router, env: environment, signInLink: "/user/Login.htm", signInRedirectParam: "redirect", logo: img, menu: LAYOUT_MENU_ITEMS, submenu, transparent: header == null ? void 0 : header.transparent, disabled: header == null ? void 0 : header.disabled, footerColumns: FOOTER_COLUMNS, primaryCTALink: HEADER_CTAS.primary.url, primaryCTALabel: HEADER_CTAS.primary.label, secondaryCTALink: HEADER_CTAS.secondary.url, secondaryCTALabel: HEADER_CTAS.secondary.label, sticky: true, children })
  ] });
};
export {
  ZillowNewsLayout as default
};
